export const routes = {
    home: '/',
    apps: '/apps',
    games: '/games',
    termsAndConditions: '/terms-and-conditions',
    privacyPolicy: '/privacy-policy',
    login: '/login',
    signup: '/signup',
    me: '/me',

    wordCounter: '/word-counter',
    myIP: '/my-ip',
    // passwordGenerator: '/password-generator',
    // taxCalculator: '/tax-calculator',
    // exponentialInterestCalculator: '/exponential-interest-calculator',
    // compoundInterestCalculator: '/compound-interest-calculator',

    ticTacToe: '/tic-tac-toe',

    undefined: '*'
}